<div class="div-pr0">
    <ion-grid>
        <ion-row class="row ml-3">
            <ion-col size="auto">
                <div class="w-40"></div>
                <input [disabled]="disabled" id="24h0" class="m-3 h-25 slot-input w-36" type="text" placeholder="00" maxlength="3" (keydown)="keyTime($event,3,0)" (keyup)="timeLength(3,0)" (focus)="focusTime(0)" (focusout)="unfocusHours(0)"/>
                <ion-label class= "m-3 h-25" class="label-0">:</ion-label>
            </ion-col>
            <ion-col size="auto">
                <div class="w-40"></div>
                <input [disabled]="disabled" id="24m0" class="m-3 h-25 slot-input w-36" type="text" placeholder="00" maxlength="3" (keydown)="keyTime($event,6,0)" (keyup)="timeLength(6,0)" (focus)="focusTime(0)"/>
            </ion-col>
            <ion-col size="auto">
                <div id="hidden_div0" class="w-50">
                    <select [disabled]="disabled" id="AMPM0" class="m-3 h-25" (change)="changeAMPM($event.target.value,0)">
                        <option value='AM'>AM</option>
                        <option value='PM'>PM</option>
                    </select>
                </div>
                <div id="separator_col0">
                    <div class="sep0-pr">
                        <ion-label class= "m-3 h-25" class="label-2">-</ion-label>
                    </div>
                </div>
            </ion-col>

            <div id="separator_col">
                <div class="sep1-pr">
                    <ion-label class= "m-3 h-25" class="label-1">-</ion-label>
                </div>
            </div>

            <ion-col size="auto">
                <div class="w-40"></div>
                <input [disabled]="disabled" id="24h1" class="m-3 h-25 slot-input w-36" type="text" placeholder="00" maxlength="3" (keydown)="keyTime($event,3,1)" (keyup)="timeLength(3,1)" (focus)="focusTime(1)" (focusout)="unfocusHours(1)"/>
                <ion-label class= "m-3 h-25" class="label-0">:</ion-label>
            </ion-col>
            <ion-col size="auto">
                <div class="w-40"></div>
                <input [disabled]="disabled" id="24m1" class="m-3 h-25 slot-input w-36" type="text" placeholder="00" maxlength="3" (keydown)="keyTime($event,6,1)" (keyup)="timeLength(6,1)" (focus)="focusTime(1)"/>
            </ion-col>
            <ion-col size="auto">
                <div id="hidden_div1" class="w-50">
                    <select [disabled]="disabled" id="AMPM1" class="m-3 h-25" (change)="changeAMPM($event.target.value,1)">
                        <option value='AM'>AM</option>
                        <option value='PM'>PM</option>
                    </select>
                </div>
            </ion-col>
            <ion-col size="auto">
                <select id="selH" style="display:none" class="m-3 h-25" (change)="onChange($event.target.value)">
                    <option value='12'>12h</option>
                    <option value='24'>24h</option>
                </select>
            </ion-col>
        </ion-row>
        <ion-row id="slidesRow" class="row-width">
            <ion-col size="auto">
                <div class="contain-0">
                    <div id="hidden_div2" class="contain-1">
                        <swiper-container #slider0 class="h-100" direction="vertical" slides-per-view="5" loop="true" centered-slides="true" initial-slide="0" (ionSlideWillChange)="onChangeHoursSlide($event, 0)">
                            <swiper-slide class="slide-0" *ngFor="let item of items">{{item}}</swiper-slide>
                        </swiper-container>
                    </div>
                    <div id="hidden_div3" class="contain-1">
                        <swiper-container #slider1 class="h-100" direction="vertical" slides-per-view="5" loop="true" centered-slides="true" initial-slide="0" (ionSlideWillChange)="onChangeHoursSlide($event, 0)">
                            <swiper-slide class="slide-0" *ngFor="let item of items3">{{item}}</swiper-slide>
                        </swiper-container>
                    </div>
                </div>
            </ion-col>
            <ion-col size="auto">
                <div id="hidden_div6" class="w-40">
                    <swiper-container #slider2 class="h-100" direction="vertical" slides-per-view="5" loop="true" centered-slides="true" initial-slide="0" (ionSlideWillChange)="onChangeMinutesSlide($event, 0)">
                        <swiper-slide class="slide-0 ml-6" *ngFor="let item of items2">{{item}}</swiper-slide>
                    </swiper-container>
                </div>
            </ion-col>
            <ion-col size="auto"><div id="separator_col1" class="w-50"></div></ion-col>
            
            <div>
                <div class="sep1-pr">
                    <ion-label class= "m-3 h-25" class="label-1"></ion-label>
                </div>
            </div>
            
            <ion-col size="auto">
                <div class="contain-2 w-40 h-100 ml-3">
                    <div id="hidden_div4" class="contain-1">
                        <swiper-container #slider3 class="h-100" direction="vertical" slides-per-view="5" loop="true" centered-slides="true" initial-slide="0" (ionSlideWillChange)="onChangeHoursSlide($event, 1)">
                            <swiper-slide class="slide-0" *ngFor="let item of items">{{item}}</swiper-slide>
                        </swiper-container>
                    </div>
                    <div id="hidden_div5" class="contain-1">
                        <swiper-container #slider4 class="h-100" direction="vertical" slides-per-view="5" loop="true" centered-slides="true" initial-slide="0" (ionSlideWillChange)="onChangeHoursSlide($event, 1)">
                            <swiper-slide class="slide-0" *ngFor="let item of items3">{{item}}</swiper-slide>
                        </swiper-container>
                    </div>
                </div>
            </ion-col>
            <ion-col size="auto">
                <div id="hidden_div7" class="w-40">
                    <swiper-container #slider5 class="h-100" direction="vertical" slides-per-view="5" loop="true" centered-slides="true" initial-slide="0" (ionSlideWillChange)="onChangeMinutesSlide($event, 1)">
                        <swiper-slide class="slide-0 ml-6" *ngFor="let item of items2">{{item}}</swiper-slide>
                    </swiper-container>
                </div>
            </ion-col>
            <ion-col size="auto"><div class="w-50"></div></ion-col>
            <ion-col size="auto"><div class="w-50"></div></ion-col>
        </ion-row>
        <div id="hidden_div8" class="picker-bar">:</div>
        <div id="hidden_div9" class="picker-bar">:</div>
    </ion-grid>
</div>